<template>
  <div>
    <v-text-field
      label="Title"
      :value="title"
      type="text"
      :rules="validationRules"
      filled
      :disabled="true"
      :loading="loading"
    />
    <v-text-field :label="label" v-model="recipeId" type="text" :rules="validationRules" filled />
  </div>
</template>

<script>
import fieldMixin from '@/mixins/LeanField';

export default {
  name: 'ViluaRecipe',
  mixins: [fieldMixin],
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      api_url: '',
      inquiry: null,
      loading: false,
      recipeId: '',
      title: ''
    };
  },
  mounted() {
    if (this.initialValue) {
      this.title = this.initialValue.title;
      this.recipeId = this.initialValue.id;
    }

    // get API URL from terraform-expots.json
    fetch('/terraform-exports.json')
      .then(response => response.json())
      .then(data => this.api_url = data.VUE_APP_RECIPE_API_URL.value);
  },
  methods: {
    clearTitle() {
      this.title = '';
      this.loading = false;
      clearTimeout(this.inquiry);
    },
    async makeCall(id) {
      try {
        const URL = `https://${this.api_url}/${id}`;
        const getApiData = await fetch(URL).then((response) => response.json());
        this.title = getApiData.name;
        this.value = { id: id, title: getApiData.name };
      } catch (err) {
        this.clearTitle();
      }
    },
  },
  watch: {
    recipeId(id) {
      if (id.match('^[0-9]+$')) {
        this.loading = true;
        clearTimeout(this.inquiry);
        this.inquiry = setTimeout(() => {
          this.makeCall(id).then(() => {
            this.loading = false;
          });
        }, 1000);
      } else {
        this.clearTitle();
      }
    }
  }
};
</script>
